module.exports = __webpack_public_path__ + "img/chiffre-1.4da47909.svg";